<template>

	<div class="article-tile article-tile--text-limit" :class="classObj" :data-grid-width="width" :data-grid-height="height">


		<div  v-if="displayTile == 'ChapteredContent'">
			<featured-insights-block :content="tileObject" />
		</div>



		{{ /* Found in _ArticleCalloutWidget.cshtml */ }}
		<div class="article-tile-info-area" v-if="displayTile != 'ChapteredContent'">
			<a :href="url" class="article-tile-img-link" v-if="hasImage">
				<div class="article-tile-img background-cover" :style=" { 'background-image': 'url(' + encodeURI(imageUrl) + ')' }">				
				</div>
			</a>

			<div class="article-tile-copy">
				<div class="article-tile-type" v-if="hasIcon">
					<ArticleTypeEyebrow :icon="icon">{{heading}}</ArticleTypeEyebrow>
				</div>

				<h3 class="article-tile-title mb-1" :class="{ 'heading-4': !isDark, 'heading-callout': isDark }" ><slot name="title">Hamilton Lane Liquidity Scorecard</slot></h3>
				<div class="article-tile-published-date">{{tileObject.FormattedPublishedDate}}</div>
				<p class="article-tile-description"><slot name="description">It’s Market Overview season at Hamilton Lane, so we thought it’d be fun to share a small highlight from this year’s presentation…</slot></p>
				<div class="article-tile-link">
					<Link :url="url"><slot name="link">Read the blog post</slot></Link>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

import ArticleTypeEyebrow from '../components/ArticleTypeEyebrow.vue';
import Link from "../components/Link.vue";

import FeaturedInsightsBlock from '../systems/FeaturedInsightsBlock.vue';

export default {
	components: {
		ArticleTypeEyebrow,
		FeaturedInsightsBlock,
		Link
	}, 
	props: {
		icon: {
			type: String,
			default: "eye"
		},
		heading: {
			type: String,
			default: "insight"			
		},
		url: {
			type: String,
			default: "/"
		},
		imageUrl: {
			type: String,
			default: ""
		},
		displayTile: {
			type: String,
			default: "Simple"
		},
		tileObject: {		// full info about this tile.. mainly for chaptered content.
			type: Object,
			default: function() {
				return {}
			}
		}
	},
	computed: {
		hasIcon() {
			return this.icon != "";
		},
		hasImage() {
			return this.imageUrl != "" && (this.displayTile == "Featured" || this.displayTile == "WithImage") ;
		},
		isDark() {
			if(this.displayTile == "Callout" || this.displayTile == "CalloutNotched") {
				return true;
			} else {
				return false;	
			}
			
		},
		classObj() {

			if(this.displayTile == "ChapteredContent") {
				return {
					'article-tile--chaptered-content': true
				}
			}

			let isDark = this.displayTile == "Callout" || this.displayTile == "CalloutNotched";

			return { 
				'background-is-light-grey': this.displayTile == "Featured", 
				'background-is-dark': isDark, 
				'background-is-midnight': isDark,
				'background-is-navy': isDark, 
				'background-is-left-notched': this.displayTile == "CalloutNotched", 
				'article-tile--tall': isDark || this.displayTile == "Featured" || this.hasImage,
				'article-tile--featured': this.displayTile == "Featured", 
				'article-tile--with-image': this.hasImage,
				'article-tile--no-image': !this.hasImage,
				'article-tile--dark': isDark
			}
		},
		width() {
			if( this.displayTile == "ChapteredContent" )
				return 3;
			else
				return 1;
		},
		height() {
			if(this.displayTile == "Callout" || this.displayTile == "CalloutNotched" || this.hasImage || this.displayTile == "ChapteredContent") {
				return 2;
			} else {
				return 1;
			}
		}
	}
}

</script>

<style lang="scss">

.related-articles .article-tile {
	border-top: 5px solid #007DC3;
}

$regImgHeight: 230px;
body.ie {
	.article-tile {
		//margin-bottom: 1rem;


		&.article-tile--chaptered-content {
			grid-column: span 5 !important;
			

		}

		&.article-tile--tall {
			// Mobile size is 1 column, so no need to span
			grid-row: span 3 !important;		
		}
		.article-tile-description {
			max-height: 6em;
		}
		&.article-tile--featured:not(.article-tile--dark) {

			height: 500px;
			.article-tile-info-area {

				height: 500px;
				grid-template-rows: 240px 20px 240px;
			
				.article-tile-img-link {
					grid-row: 1 / 1;
					grid-column: 1 / 2
				}
				.article-tile-copy {
					grid-row: 3 / 3;
					grid-column: 1 / 1
				}

				.article-tile-description {
					max-height: 4em;
				}
			}

		}

	}
}
	.article-tile {
		// max-width: 475px;
		position: relative;


		.article-tile-title {
			text-transform: none;
		}

		.article-tile-title + .article-tile-published-date {
			margin-top: -0.2em;
			margin-bottom: 0.3em;
		}

		// Single column doesn't need min height
		@include respond-above(md) {
			min-height: 300px;
		}

		&--no-image {
			padding: 25px 25px;

			@include respond-above(md) {
				min-height: 200px;
			}
		}

		&--with-image {
			.article-tile-copy {
				padding: 25px 25px;
			}
		}
		
		&--fixed-image {
			.article-tile-img {
				background-size: contain !important;
			}
		}

		&--w80 {
			.article-tile-img {
				background-size: 80% !important;
			}
		}

		.article-tile-img {
			min-height: 225px;
			width: 100%;
			height: 100%;

		}

		.article-tile-description {
			overflow: hidden;
			display: -webkit-box;
			//-webkit-line-clamp: 4;
			-webkit-box-orient: vertical;  	
			text-overflow: ellipsis;
		}

		&.article-tile--tall.article-tile--no-image {
			.article-tile-description {
				-webkit-line-clamp: 10;
			}
		}


		&.article-tile--featured:not(.article-tile--dark) {
			
		}

		&.article-tile--chaptered-content {
			grid-column: span 3;
			
			@include respond-below(lg) {
				grid-column: span 2;
			}
			@include respond-below(md) {
				grid-column: span 1;
			}
		}

		&.article-tile--tall {
			// Mobile size is 1 column, so no need to span
			@include respond-above(md) {
				grid-row: span 2;
			}
						
		}

		&.article-tile--featured:not(.article-tile--dark) {

			height: 100%;
			.article-tile-info-area {
				display: grid;
				height: calc(100% - 25px);
				grid-template-rows: 50% 50%;
				
				grid-gap: 25px;

				// single column & 2 column
				@include respond-below(md) {
					grid-template-rows: auto auto;
				}

				.article-tile-img-link {
					grid-row: 1 / 1;
					grid-column: 1 / 1
				}
				.article-tile-copy {
					grid-row: 2 / 2;
					grid-column: 1 / 1;
					@include respond-above(md) {
						margin-bottom: 50px;
					}
				}
			}
			&.article-tile--text-limit {
				.article-tile-description {
					-webkit-line-clamp: 3;
				}
			}
		}



		

		&.article-tile--dark {
			padding: 25px 25px;
			.article-tile-title.heading-callout{
				line-height: 1.25em;
				margin-bottom: 0;
			}

			.article-type-eyebrow-dark{
				color: $orangeText;
			}
		}

		.article-tile-img-link {
			.article-tile-img {
				transition: opacity 0.1s linear;
			}
		}
		.article-tile-img-link:hover {
			.article-tile-img {
				opacity: 0.85;
			}

		}

		&.article-tile--text-limit {
			.article-tile-description {
				-webkit-line-clamp: 4;
			}
		}

		&.article-tile--no-text-limit {
			.article-tile-description {
				-webkit-line-clamp: initial !important;
			}
		}
	}

	.article-tile-grid--limit-copy .article-tile .article-tile-description {
		-webkit-line-clamp: 4 !important;
	}
	.article-tile-grid--limit-copy .article-tile.article-tile--featured .article-tile-description {
		-webkit-line-clamp: 3 !important;
	}
	.article-tile-grid--limit-copy .article-tile.article-tile--no-image .article-tile-description {
		-webkit-line-clamp: 3 !important;
	}
	.article-tile-grid--limit-copy .article-tile.article-tile--no-image.article-tile--featured .article-tile-description {
		-webkit-line-clamp: 5 !important;
	}
	
	.ktc-widget {
		.article-tile{
			.article-tile-img {
				height: 50px;
			}
			&.article-tile--featured:not(.article-tile--dark) {

				height: auto !important;
				.article-tile-info-area {
					display: block !important;
				}
			}
		}
	}

</style>
